import { Backend, IApi } from './backend'
import { AxiosResponse } from 'axios'
import { IRequest } from './index'
import ILink from './../models/link'

export default class Link extends Backend {
  static getTableData(
    request: IRequest
  ): Promise<AxiosResponse<{ rows: ILink[]; count: number }>> {
    const api: IApi = {
      url: '/api/link/tableData',
      method: 'get',
      data: { request }
    }
    return this.request<{ rows: ILink[]; count: number }>(api)
  }
  static createOrUpdate(data: any): Promise<AxiosResponse<ILink>> {
    const api: IApi = {
      url: '/api/link/createOrUpdate',
      method: 'post',
      data
    }
    return this.request<ILink>(api)
  }
  static delete(id: number): Promise<AxiosResponse> {
    const api: IApi = {
      url: `/api/link/${id}`,
      method: 'delete'
    }
    return this.request(api)
  }
}
